// 实现商品SKU分组
export function cartesianGroup(options = []) {
  return (groupId = 'groupId', groupName = 'groupName') => {
    const groupIds = [...new Set(options.map((item) => item[groupId]))];
    const values = groupIds.map((id) => {
      const value = {};
      value[groupId] = id;
      value.children = options.filter((item) => item[groupId] === id);
      value[groupName] = (value.children[0] || {})[groupName];
      return value;
    });
    return values;
  };
}

// 实现商品SKU算法（笛卡尔乘积）
export function cartesianSku(spec = []) {
  let sku = spec.reduce(
    (x, y) => {
      let arr = [];
      x.forEach((x) => y.forEach((y) => arr.push(x.concat([y]))));
      return arr;
    },
    [[]]
  );
  return sku;
}

export default { cartesianGroup, cartesianSku };
